export const MODAL_COLLAPSED_CHIP_GAP = 4;

export default function countVisibleCollapsedFilters({
  rowItems = [],
  itemWidths = {},
  containerWidth = 0,
  plusWidth = 70,
  gap = 0,
} = {}) {
  if (!rowItems.length || containerWidth <= 0) return 0;

  let totalWidth = 0;
  let visibleItemsCount = 0;

  for (let i = 0; i < rowItems.length; i++) {
    const itemWidth = itemWidths[rowItems[i]?.id]?.width || 0;
    const gapBefore = visibleItemsCount > 0 ? gap : 0;
    const needsOverflowBadge = i < rowItems.length - 1;
    const additionalSpace = needsOverflowBadge ? plusWidth + gap : 0;
    if (totalWidth + gapBefore + itemWidth + additionalSpace < containerWidth) {
      totalWidth += gapBefore + itemWidth;
      visibleItemsCount += 1;
    } else {
      break;
    }
  }

  return visibleItemsCount;
}
